import { render } from "./ProjectSources.vue?vue&type=template&id=7a88849c"
import script from "./ProjectSources.vue?vue&type=script&lang=js"
export * from "./ProjectSources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__